import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from "../endpoint";
import { Options } from 'selenium-webdriver/safari';


@Injectable()
export class UsersService {

  constructor(
    private http: HttpClient,
    
  ) { }

  private basePath = ENPOINT.url;

  getUsers(): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders, 
      withCredentials: true,
      params: new HttpParams()
      .set('flagAdm', 'X')
        }
    // console.log(options);
    return  request = this.http.get(this.basePath + 'users', options)
  }




  filterUsers(tipo,valor): Observable<any> {

    //_users/findUsers?dc=1527208818917&tipo=1&valor=borrar&page=1&start=0&limit=25
    let request;
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders, 
      withCredentials: true,
      params: new HttpParams()
      .set('tipo', tipo)
      .set('valor', valor)
      .set('flagAdm', "X")
        }
    // console.log(options);
    return  request = this.http.get(this.basePath + 'users/findUsers', options)
      .pipe(
        retry(3)
      );
  }



  createUser( userObj:any ): Observable<any>{
    
    let request; 
    let usuario = {};
    let body ={ usuario: userObj};
    const headers = new HttpHeaders()
   .append('Content-Type' , 'application/json')
   .append('Accept-Language','en-US,en;q=0.5')
   let options = {
    headers: headers, 
    withCredentials: true
      }

    return request = this.http.post(this.basePath + 'users',body,options)
    .pipe(
      retry(2)
    )

  }



  updateUser( id,userObj:any ): Observable<any>{
    
    let request; 
    let usuario = {};
    let body ={ usuario: userObj};
    const headers = new HttpHeaders()
   .append('Content-Type' , 'application/json')
   .append('Accept-Language','en-US,en;q=0.5')
   let options = {
    headers: headers, 
    withCredentials: true
      }

    return request = this.http.post(this.basePath + 'users/'+id,body,options)
  }

  // deleteUser(id){
  //   let request; 
  //   let userId = id;
    
  //   const headers = new HttpHeaders()
  //  .append('Content-Type' , 'application/json')
  //  .append('Accept-Language','en-US,en;q=0.5')
  //   return request = this.http.delete(this.basePath + 'users/'+userId,{ headers: headers })
  //   .pipe(
  //     retry(2)
  //   )
  // }

  deleteUser(id): Observable<any> {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT, DELETE')
    const options = {
      headers: httpHeaders,
      withCredentials: true,
    };
    return this.http.delete(this.basePath + 'users/'+id, options);
  }
  
  borrarUser(id: string): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('uuid', '')
      };
  return this.http.delete(this.basePath + 'users/'+id, options);
  }
  deleteHero (id): Observable<any> {
    const idUser = id;
    const url = `${this.basePath+'users/'}${id}`;
    const httpOptions = {
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' },
      )
    };
    return this.http.delete(url).pipe(
      retry(2)
    );
  }



  getSociedades(): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true
        }
    // console.log(options);
    return  request = this.http.get(this.basePath + 'config/sociedades', options)
      .pipe(
        retry(3)
      );
  }






  getCECOs(): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', '')
     
        }
    // console.log(options);
    return  request = this.http.get(this.basePath + 'catalog/obtener-cecos', options)
      .pipe(
        retry(3)
      );
  }


  getUsersPermissions(user:number): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      
     
        }
    // console.log(options);
    return  request = this.http.get(this.basePath + 'users/'+user+'/permisos', options)
      .pipe(
        retry(3)
      );
  }


  
  estatusUsuario( id, estatus ): Observable<any>{
    
    let request; 
    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders, 
      withCredentials: true,
      params: new HttpParams()
      .set('id', id)
      .set('activo', estatus)
    }

    return request = this.http.put(this.basePath + 'users/estatus','',options)
    .pipe(
      retry(2)
    )

  }



}



// WEBPACK FOOTER //
// ./src/app/services/admin/users.service.ts